import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TopBar } from '../../components/TopBar';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setShowFiltersModal, setOrderField } from '../../actions/filters';
import { EOrderField } from '../../repositories/favorites/v1/web-get-user-favorites';
import { CheckboxAllContainer } from '../CheckboxAllContainer/CheckboxAllContainer';
import { TotalCountContainer } from '../TotalCountContainer';
import { MassActionsContainer } from '../MassActions';
import { FixedPanel } from '../../components/FixedPanel';
import { selectFilters } from '../../selectors/filters';
import { selectSelectedFolder } from '../../selectors/folders';
import { EEntityType } from '../../types/filters';
import { useTopBarCount } from '../../hooks/topBar';

export function TopBarContainer() {
  const dispatch = useDispatch();
  const { favoriteEntityType, orderField } = useSelector(selectFilters);
  const selectedFolder = useSelector(selectSelectedFolder);
  const filtersVisible = !selectedFolder && favoriteEntityType !== EEntityType.Newbuilding;
  const topBarCount = useTopBarCount();

  return (
    <FixedPanel>
      <TopBar
        orderField={orderField}
        checkbox={Boolean(topBarCount.count) && <CheckboxAllContainer />}
        total={<TotalCountContainer />}
        massActions={Boolean(topBarCount.count) && <MassActionsContainer />}
        filtersVisible={filtersVisible}
        getFavoriteEntities={(orderField?: EOrderField | null) =>
          dispatch(fetchFavoriteEntities({ offset: 0, orderField }))
        }
        setShowFiltersModal={(showFiltersModel: boolean) => dispatch(setShowFiltersModal(showFiltersModel))}
        setOrderField={(type: EOrderField) => dispatch(setOrderField(type))}
      />
    </FixedPanel>
  );
}
